<template>
  <div :class="$b()">
    <div :class="$b('row-container')">
      <div
        :class="[
          $b('row', {
            on: modelValue === onValue,
            off: modelValue === offValue,
          })
        ]"
      >
        <label
          v-if="$slots['on-icon']"
          :class="$b('item', { on: true })"
        >
          <input
            :class="$b('input')"
            type="radio"
            :value="onValue"
            :checked="modelValue === onValue"
            @change="$emit('update:modelValue', onValue)"
          />
          <slot name="on-icon" />
        </label>
        <label
          v-if="$slots['off-icon']"
          :class="$b('item', { off: true })"
        >
          <input
            :class="$b('input')"
            type="radio"
            :value="offValue"
            :checked="modelValue === offValue"
            @change="$emit('update:modelValue', offValue)"
          />
          <slot name="off-icon" />
        </label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HorizontalToggle',
  props: {
    modelValue: {
      type: [String, Boolean],
      default: null,
    },
    onValue: {
      type: [String, Boolean],
      default: 'on',
    },
    offValue: {
      type: [String, Boolean],
      default: 'off',
    },
  },
  emits: ['update:modelValue'],
}
</script>

<style lang="postcss">
.HorizontalToggle {
  width: 72px;

  @screen lg {
    width: 80px;
  }
}

.HorizontalToggle__row-container {
  @apply relative bg-grey-light z-0 p-[4px] rounded-[4px];
}

.HorizontalToggle__row {
  @apply relative grid grid-cols-2 w-full z-0 gap-[4px];
  grid-auto-columns: 28px;
  grid-auto-flow: column;

  @screen lg {
    grid-auto-columns: 32px;
  }

  &::before {
    @apply hidden absolute transition-transform top-0;
    content: '';
    background-image: var(--gradient-default);
    border-radius: 4px;
    width: 28px;
    height: 100%;
    transform: translate3d(0, 0, 0);
    transition-duration: 0.3s;
    z-index: 1;

    @screen lg {
      width: 32px;
    }
  }
}

.HorizontalToggle__row--on::before {
  @apply block;
  transform: translate3d(1px, 0, 0);
}

.HorizontalToggle__row--off::before {
  @apply block;
  transform: translate3d(calc(100% + 6px), 0, 0);
}

.HorizontalToggle__item {
  @apply text-off-black text-center flex justify-center items-center cursor-pointer;
  -webkit-tap-highlight-color: transparent;
  flex: 1 1 100%;
  appearance: none;
  z-index: 2;

  height: 28px;

  &:not(&--active) {
    transition: colour 0.25s ease-in-out;
  }

  &:focus {
    outline: none;
  }

  &:hover:not(&--active) {
    @apply opacity-60;
  }

  input {
    @apply absolute;
    appearance: none;
  }
}

.HorizontalToggle__row--on .HorizontalToggle__item--on svg {
  --vision-icon-fill: #fff !important;
}

.HorizontalToggle__row--off .HorizontalToggle__item--off svg {
  --vision-icon-fill: #fff !important;
}
</style>